import { CmErrorText, CmLongLoading } from '@/components/uiParts';

import { CamelOrderCouponsTemplate } from './CamelOrderCouponsTemplate';
import { useCamelOrderCoupons } from './useCamelOrderCoupons';

const CamelOrderCouponsPage: React.FC = () => {
  const {
    changeUrlHandler,
    coupons,
    isLoading,
    sites,
    targetSite,
    error,
    handleStatusChange,
  } = useCamelOrderCoupons();

  if (error !== null || targetSite === null) {
    // targetSiteがnullのときはerrorがnot null
    if (error) {
      return <CmErrorText>{error?.message}</CmErrorText>;
    } else {
      return <CmErrorText>targetSiteがnullでした</CmErrorText>;
    }
  }
  if (isLoading) {
    return <CmLongLoading />;
  }

  return (
    <CamelOrderCouponsTemplate
      {...{ changeUrlHandler, coupons, isLoading, sites, targetSite }}
      handleStatusChange={handleStatusChange}
    />
  );
};

export default CamelOrderCouponsPage;
